import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { getLang, getUrlBasedOnCountry } from "../../Helpers/functions";
import { toSafeRedirect } from "../../Helpers/safe-redirect";

const PaymentCheck = () => {
    const [searchParams] = useSearchParams();
    const redirectTo = searchParams.get("redirectTo"); 

    useEffect(() => {
        // the address comes from the link, so only our own addresses are followed
        const target = toSafeRedirect(redirectTo);
        if (!target) {
            Sentry.captureMessage('PaymentCheck: redirectTo was rejected', {
                level: 'warning',
                extra: { redirectTo },
            });
        }
        window.top.location.replace(
            target ?? getUrlBasedOnCountry(localStorage.getItem('countryCode') ?? 'jo', getLang())
        );
    },[redirectTo])

    return  <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="spinner-border text-primary" role="status">
        </div>
    </div>
};
export default PaymentCheck;
